export default __webpack_public_path__ + "media/images/react_icons/profile-f94eb35c9c1882505f8c9567e93026cc.svg";